
export enum MenuSlug {
  CART_NEED_HELP = "cart-need-help"
}